export default "__VITE_ASSET__BPIf65FZ__"